/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessCreateRole } from "../funcs/accessCreateRole.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Role } from "../models/components/role.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  CreateRoleRequest,
  CreateRoleSecurity,
} from "../models/operations/createrole.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateRoleMutationVariables = {
  request: CreateRoleRequest;
  security?: CreateRoleSecurity | undefined;
  options?: RequestOptions;
};

export type CreateRoleMutationData = Role;

export type CreateRoleMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * createRole access
 *
 * @remarks
 * Create a new custom role.
 */
export function useCreateRoleMutation(
  options?: MutationHookOptions<
    CreateRoleMutationData,
    CreateRoleMutationError,
    CreateRoleMutationVariables
  >,
): UseMutationResult<
  CreateRoleMutationData,
  CreateRoleMutationError,
  CreateRoleMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateRoleMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateRole(): MutationKey {
  return ["@gram/client", "access", "createRole"];
}

export function buildCreateRoleMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateRoleMutationVariables,
  ) => Promise<CreateRoleMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateRole(),
    mutationFn: function createRoleMutationFn({
      request,
      security,
      options,
    }): Promise<CreateRoleMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(accessCreateRole(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
